/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { Fragment, useContext, useEffect, useState } from 'react'
import ReactDOMServer from "react-dom/server";
import { Link, useHistory } from 'react-router-dom'
import { toast } from 'react-hot-toast';

import PrimaryButton from '../../Components/Buttons/PrimaryButton'
import Card from '../../Components/Card/Card'
import Header from '../../Components/Header/Header'
import Navbar from '../../Components/Navbar/Navbar'

import SiteTemplate from '../../Components/SiteTemplate/SiteTemplate';
import ThankYouTemplate from '../../Components/SiteTemplate/ThankYouTemplate';
import { authContext } from '../../store/AuthContext';


const Sites = () => {
    const token = JSON.parse(localStorage.getItem('token'));
    const serverURL = process.env.REACT_APP_SERVER_URL;

    const history = useHistory();

    const authCtx = useContext(authContext);

    if (authCtx.adminType !== 'super' && authCtx.adminType !== 'data') {
        history.push('/form');
    }

    const [sites, setSites] = useState([]);


    const getSites = async () => {
        const res = await toast.promise(
            axios({
                method: 'GET',
                url: `${serverURL}/api/sites`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }),
            {
                loading: 'Fetching...',
                success: "Data fetched successfully",
            }
        )

        if (res && res.status === 200) {
            const { data } = res.data;
            setSites(data);
        }
    }

    const deleteSite = async (id) => {

        if (!id) {
            toast.error('Kindly provide an ID!');
        }

        try {
            const resFloorPlans = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/floor-plan/property/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resFloorPlans || resFloorPlans.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resOverviewImage = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/overview-image/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resOverviewImage || resOverviewImage.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resPartnerLogo = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/partner-logo/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resPartnerLogo || resPartnerLogo.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resBannerImage = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/banner-image/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resBannerImage || resBannerImage.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resWhyToChooseImage = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/whytochoose-image/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resWhyToChooseImage || resWhyToChooseImage.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resGalleryImage = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/gallery-image/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resGalleryImage || resGalleryImage.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resUnits = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/units/property/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resUnits || resUnits.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        try {
            const resBrochure = await toast.promise(
                axios({
                    method: "DELETE",
                    url: `${serverURL}/api/brochure/${id}`,
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }), {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
            )

            if (!resBrochure || resBrochure.status !== 200) {
                toast.error("Couldn't delete the data");
            }
        } catch (error) {

        }

        const res = await toast.promise(
            axios({
                method: "DELETE",
                url: `${serverURL}/api/sites/${id}`,
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }),
            {
                loading: 'Deleting...',
                success: "Data deleted successfully",
                error: "Couldn't delete the data"
            }
        )

        if (res && res.status === 200) {
            let newSites = [...sites];
            newSites = newSites.filter((site) => site._id !== id)
            setSites(newSites);
        }

    }

const downloadHandler = (id) => {
  const serverURL = process.env.REACT_APP_SERVER_URL;

  try {
    const html = ReactDOMServer.renderToStaticMarkup(
      <SiteTemplate id={id} serverURL={serverURL} />
    );
    const htmlWDoc = "<!DOCTYPE html>" + html;
    const blob = new Blob([htmlWDoc], { type: "text/html;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "index.html";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    toast.error("Failed to generate index.html");
    console.error("SiteTemplate Error:", err);
  }

  try {
    const htmlThankYou = ReactDOMServer.renderToStaticMarkup(
      <ThankYouTemplate id={id} serverURL={serverURL} />
    );
    const htmlThankYouWDoc = "<!DOCTYPE html>" + htmlThankYou;
    const blobThankYou = new Blob([htmlThankYouWDoc], { type: "text/html;charset=utf-8" });
    const urlThankYou = URL.createObjectURL(blobThankYou);
    const linkThankYou = document.createElement("a");
    linkThankYou.href = urlThankYou;
    linkThankYou.download = "thank-you.html";
    document.body.appendChild(linkThankYou);
    linkThankYou.click();
    document.body.removeChild(linkThankYou);
  } catch (err) {
    toast.error("Failed to generate thank-you.html");
    console.error("ThankYouTemplate Error:", err);
  }
};

    const editSiteHandler = (id) => {
        history.push(`/sites/edit/${id}`)
    }

    useEffect(() => {
        getSites();
    }, [])

    return (
        <Fragment>
            <Header />
            <Navbar />
            <div className='container' >
                <div className='row'>
                    <div className="col-lg-12">
                        <Link to='/sites/add' className='mt-20 mb-20 float-right'>
                            <PrimaryButton >
                                <i className='fa fa-plus'></i> &nbsp;  Add Microsite
                            </PrimaryButton>
                        </Link>
                    </div>
                    <div className='col-lg-12' >
                        <div className="row">
                            {
                                sites.map((site) => {
                                    return (
                                        <Card key={site._id} siteId={site._id} title={site.name} img={`${serverURL}/${site.bannerImage}`} onDelete={() => deleteSite(site._id)} onDownload={() => downloadHandler(site._id, site.title)} onEdit={() => editSiteHandler(site._id)} />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Sites